<div
  lnClickOutSide
  (clickOutside)="closeDropdown()"
  (mouseLeave)="closeDropdown()"
  [ngClass]="[
    'relative h-[48px] max-w-[345px] rounded-md border border-cafe focus:outline-none bg-blanco',
    showContactOptionError() ? 'border-red-500' : isOpen() ? 'border-verde border-2' : ''
  ]">
  <!-- Dropdown button -->
  <button type="button" (click)="toggleDropdown()" [ngClass]="[isOpen() ? 'pb-1' : 'pb-0', 'flex h-[48px] w-full overflow-hidden items-center']">
    <div class="flex w-full flex-row justify-between pl-[16px] pr-[11px] items-center">
      <div
        class="mr-[5px]   overflow-hidden truncate text-start text-base font-normal text-cafe">
        {{ selected() }}
      </div>
      <div class="flex flex-col transform items-center transition-transform duration-200" [ngClass]="{ 'rotate-180': isOpen() }">
        <ln-chevron-down-svg-icon [class]="'h-[12px] w-[24px]'" fillColor="#372121"></ln-chevron-down-svg-icon>
      </div>
    </div>
  </button>

  <!-- Dropdown menu -->
  @if (isOpen()) {
    <div
      class="absolute z-10 block w-full rounded-md border border-gray-300 bg-white shadow-lg">
      <ul class="text-base font-normal text-cafe">
        @for (option of listOfOptions; track option) {
          <li class="w-full cursor-pointer py-2 hover:bg-gray-100">
            <div class="w-full pl-[16px] text-start">
              <ln-left-checkbox-and-label
                [checkBoxAndLabelInterface]="option"
                (updateSelected)="updateSelectedOptions($event)"></ln-left-checkbox-and-label>
            </div>
          </li>
        }
      </ul>
    </div>
  }
</div>
